import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import girlDrinking from "../../assets/girl-drinking.png";

export default function MenuSummarySection() {
  useEffect(() => {
    AOS.init({ duration: 900, once: true, easing: "ease-in-out" });
  }, []);

  const courses = [
    {
      title: "Amuse-Bouche",
      description:
        "Crispy poached egg, green goddess foam, pickled onion, smoked salmon (optional) (a, g). A reimagining to ignite memories of Eggs Royale and Florentine.",
    },
    {
      title: "Starter",
      description:
        "Beef & prawn dumplings, egusi sauce (c, g, m). A modern homage to pounded yam and egusi soup.",
    },
    {
      title: "Mid-Course",
      description:
        "Zobo granita, Carlingford oyster (optional) (o). A refreshing, palate-cleansing interlude with floral depth.",
    },
    {
      title: "Main Course",
      description:
        "Confit crispy duck, ayamase-berry jus, asaro pavé (m, s, d). An ode to West African heritage, grounded in European refinement.",
    },
    {
      title: "Dessert",
      description:
        "Mango & passionfruit sorbet, chin-chin crumble, zobo foam, citrus zest (g). A bright finale of texture and tropical vibrance.",
    },
  ];

  return (
    <section className="relative bg-gradient-to-b from-[#4E5C36] via-[#3F4A2B] to-[#2E3721] text-[#F3F0E9] py-16 px-6 md:px-12 lg:px-24 overflow-hidden">
      {/* Ambient Glow Effect */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(213,203,181,0.08),transparent_60%)]"></div>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_right,rgba(243,240,233,0.05),transparent_70%)]"></div>

      <img
        src={girlDrinking}
        alt="Cup Illustration"
        className="block lg:hidden absolute top-0 right-0 w-28 md:w-40 opacity-90"
        data-aos="fade-left"
        data-aos-delay="400"
      />

      {/* Header */}
      <div
        className="relative max-w-3xl mx-auto text-center mb-12"
        data-aos="fade-up"
      >
        <p className="uppercase tracking-[0.25em] text-[#CBBE9F]/80 text-xs md:text-sm mb-5">
          Curated Dining Sequence
        </p>
        <h2 className="text-4xl md:text-6xl font-light favela text-[#F3F0E9] leading-tight">
          The Menu
        </h2>
        <p className="mt-6 text-base md:text-lg text-[#E6E1D5]/90 leading-relaxed max-w-2xl mx-auto">
          Five moments of refinement — guided by balance, heritage, and sensory
          artistry.
        </p>
      </div>

      {/* Menu Items */}
      <div className="relative w-full mx-auto grid md:grid-cols-2 lg:grid-cols-5 gap-10">
        {courses.map((course, idx) => (
          <div
            key={idx}
            className="group relative p-8 rounded-2xl bg-white/5 backdrop-blur-sm border border-white/10 hover:border-[#D5CBB5]/40 transition-all duration-500 hover:-translate-y-1"
            data-aos="fade-up"
            data-aos-delay={100 * idx}
          >
            <div className="absolute -top-3 -left-3 w-12 h-12 rounded-full bg-[#D5CBB5]/10 blur-lg group-hover:bg-[#D5CBB5]/20 transition-all duration-500"></div>
            <h3 className="text-2xl md:text-3xl lg:text-2xl font-medium text-[#FDFBF7] favela mb-4 transition-all duration-300 group-hover:text-[#D5CBB5]">
              {course.title}
            </h3>
            <p className="text-[#E6E1D5]/90 text-base md:text-lg leading-relaxed italic">
              {course.description}
            </p>
          </div>
        ))}
      </div>

      {/* Shared Servings */}
      <div
        className="relative mt-10 text-center text-[#E6E1D5]/80 italic text-base md:text-lg"
        data-aos="fade-up"
        data-aos-delay={600}
      >
        Plus shared servings for the table
      </div>

      {/* CTA */}
      <div
        className="relative mt-12 text-center"
        data-aos="zoom-in"
        data-aos-delay={700}
      >
        <button
          onClick={() => {
            document
              .getElementById("tickets")
              ?.scrollIntoView({ behavior: "smooth" });
          }}
          className="inline-block border border-[#D5CBB5] text-[#F3F0E9] hover:bg-[#D5CBB5] hover:text-[#3E4A2B] transition-all duration-300 px-12 py-4 rounded-full font-semibold tracking-wide uppercase text-sm md:text-base shadow-[0_0_20px_rgba(213,203,181,0.2)] hover:shadow-[0_0_25px_rgba(213,203,181,0.4)]"
        >
          Secure Your Seat
        </button>
      </div>
    </section>
  );
}
